module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RIpSmr/tc-custom/9781459249004.jpg?1705766095414",
      "alt": "This image is the cover for the book Surrender, The Spymaster's Men"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Surrender, The Spymaster's Men\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("To save her family and fortune, a desperate widow must turn to a dangerous spy in the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author’s Regency romantic adventure.")]), _c('br'), _c('br'), _vm._v("Once a penniless orphan, Evelyn D’Orsay became a countess and a bride at the tender age of sixteen. But the flames of revolution forced her to flee France, with the aid of a notorious smuggler. Recently widowed and without any means, Evelyn knows she must retrieve the family fortune from France for her daughter’s sake . . . but only one man can help her: the smuggler she cannot forget."), _c('br'), _c('br'), _vm._v("Jack Greystone has been smuggling since he was a small boy—and he has been spying since the wars began. An outlaw with a bounty on his head, he is in hiding when he becomes aware of the Countess’s inquiries about him. He is reluctant to come to her aid yet again, for he has never been able to forget her. But he soon realizes he’ll surrender anything to be with the woman he loves . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brenda Joyce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brenda Joyce is a New York Times bestselling author of more than 50 novels and novellas, including the popular and critically acclaimed de Warenne Dynasty Saga, a series of novels set in Regency and Victorian England. She lives on a ranch in Arizona with her dogs, broodmares and the year’s current crop of foals. If she isn’t on the back of a reining horse, she can be found madly at work in her office, penning her latest romance novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0